import React from "react";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { AutoVoucherIcon, BGVoucherIcon, LoaderIcon } from "../../../../../utils/svg";
import { formatRupiah } from "../../../../../utils/helper";

const VoucherOption = ({
  isLoadingVoucherList = false,
  maxNominalVoucher = 0,
  totalSavedB2BVoucher = 0,
  handleApplyB2BVoucher = () => {},
  isLoading = false,
  totalNominalB2BVoucher = 0,
  totalNominalVoucherGlobal = 0,
  totalNominalVoucherLoyalty = 0,
  setIsShowBottomSheet = () => {},
  setIsShowVoucher = () => {}
}) => {
  const defaultColor =
    "bg-gradient-to-r from-[var(--purplish-pink)] to-[var(--purplish-pink)]";
  return (
    <div className="w-full h-full flex flex-col my-4">
      <div className="mx-4 flex flex-col border-1 border-solid border-gray-200 rounded-xl">
        <div className="flex flex-row justify-between relative min-h-16 h-fit items-center">
          {isLoadingVoucherList ? (
            <div className="z-[1] w-full flex items-center justify-center">
              <LoaderIcon />
            </div>
          ) : (
            <div className="flex flex-row pl-2 items-center z-[1]">
              <AutoVoucherIcon />
              <div className="pl-2 h-full">
                {Boolean(maxNominalVoucher) ? (
                  <div className="text-white font-normal text-sm break-words">
                    Baik, Voucher Anda sudah terpakai
                  </div>
                ) : (
                  <div className="text-white font-normal text-sm break-words">
                    Masukkan Voucher Anda di sini
                  </div>
                )}
                {Boolean(totalSavedB2BVoucher) ? (
                  <div className="text-white font-thin text-xxs pt-1 break-words">
                    Total nilai voucher {formatRupiah(totalSavedB2BVoucher)}
                  </div>
                ) : Boolean(maxNominalVoucher) ? (
                  <div className="text-white font-thin text-xxs pt-1 break-words">
                    Total nilai voucher {formatRupiah(maxNominalVoucher)}
                  </div>
                ) : (
                  <div className="text-white font-thin text-xxs pt-1 break-words">
                    Maksimalkan diskon dengan Voucher ini sekarang
                  </div>
                )}
              </div>
            </div>
          )}
          {!isLoadingVoucherList ? (
            Boolean(totalSavedB2BVoucher) ? (
              <button
                id="summary_apply_b2b_voucher"
                onClick={() => {
                  handleApplyB2BVoucher();
                }}
                disabled={isLoading}
                className="bg-white px-4 py-2 mr-4 rounded-lg border-[var(--rose-violet)] text-[var(--rose-violet)] font-semibold min-w-fit"
              >
                Gunakan
              </button>
            ) : totalNominalB2BVoucher || totalNominalVoucherGlobal || totalNominalVoucherLoyalty ? (
              <CheckCircleIcon
                className={`h-7 w-7 z-[1] mr-4 text-green-600 `}
              />
            ) : null
          ) : null}
          <BGVoucherIcon
            className={`h-full w-full absolute rounded-lg !z-0 ${defaultColor}`}
          />
        </div>
        {!isLoadingVoucherList && (
          <div
            id="summary_view_voucher_menu"
            className="flex justify-between items-center my-4 mx-4"
            onClick={() => {
              setIsShowBottomSheet(true);
              setIsShowVoucher(true);
            }}
          >
            <div className="text-gray-600 font-semibold text-sm">
              Lihat voucher lainnya
            </div>
            <div className="h-6 w-6 flex justify-end cursor-pointer">
              <ArrowRightIcon class="h-6 w-6 text-gray-700" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VoucherOption;
